import { render, staticRenderFns } from "./patrolImprove.vue?vue&type=template&id=21e8e840"
import script from "./patrolImprove.vue?vue&type=script&lang=js"
export * from "./patrolImprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21e8e840')) {
      api.createRecord('21e8e840', component.options)
    } else {
      api.reload('21e8e840', component.options)
    }
    module.hot.accept("./patrolImprove.vue?vue&type=template&id=21e8e840", function () {
      api.rerender('21e8e840', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/patrol/vendor/patrolImprove.vue"
export default component.exports